import React, { ComponentProps } from "react"

type Props = ComponentProps<"img"> & {
  open?: boolean
  description?: string
}
const Image = ({ src, className, open, description, ...otherProps }: Props) => {
  return (
    <img
      className={className}
      style={{
        cursor: open ? "pointer" : null,
      }}
      onClick={open ? e => window.open(src) : null}
      src={src}
      alt={description}
      {...otherProps}
    />
  )
}

export default Image
